<script>
	import moment from 'moment';

	export default {
		name: 'calendar-day',
		props: {
			datetime: {
				type: String,
				default: new Date()
			},
			variant: {
				type: String,
				default: 'text'
			}
		},
		methods: {
			renderDate(datetime, dateFormat = "ddd, MMM Do YYYY, h:mm a"){
		      	let testDateUtc = moment.utc(datetime);
		      	let localDate = testDateUtc.local();
		      
		      	return localDate.format(dateFormat); 
		    },
		    renderStyle(){
		    	if(this.variant == 'danger'){
		    		return 'background: var(--bs-danger); color: white';
		    	} else if(this.variant == 'primary'){
		    		return 'background: var(--bs-blue); color: white'
		    	} else if(this.variant == 'text'){
		    		return 'background: white'
		    	} else if(this.variant == 'secondary'){
		    		return 'background: var(--bs-secondary); color: white';
		    	}
		    }
		}
	}

</script>

<template>
	<div :style="`border: 1px solid #dfe3e8; border-radius: 5px; padding: 5px; width: 100px; margin: 5px; ${renderStyle()}`" class="text-center">
		<div class="font-size-14">{{renderDate(datetime, 'ddd')}}</div>
		<div class="font-weight-bold font-size-16">{{renderDate(datetime, 'DD')}}</div>
		<div class="small">{{renderDate(datetime, 'MMM YYYY')}}</div>
	</div>
</template>